'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _retry = require('../utilities/retry');

var _retry2 = _interopRequireDefault(_retry);

var _poller = require('../utilities/poller');

var _poller2 = _interopRequireDefault(_poller);

var _isAddress = require('../utilities/isAddress');

var _isAddress2 = _interopRequireDefault(_isAddress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (_ref, _ref2) {
  var dynamicToken = _ref.dynamicToken;
  var frequency = _ref2.frequency,
      getAddress = _ref2.getAddress,
      getTokenAddress = _ref2.getTokenAddress,
      tokenBalanceUpdate = _ref2.tokenBalanceUpdate,
      tokenBalanceUpdateFailed = _ref2.tokenBalanceUpdateFailed,
      checkStart = _ref2.checkStart,
      checkStop = _ref2.checkStop;
  return function (store) {
    var dispatch = store.dispatch;

    return (0, _poller2.default)(store, {
      initialState: { currentBalance: null },

      frequency: frequency,

      checkStart: checkStart,

      checkStop: checkStop,

      // Ensure we have the proper data to run.
      checkRun: function checkRun(pollerState, reduxState) {
        return getAddress(reduxState) && (0, _isAddress2.default)(getTokenAddress(reduxState), true);
      },

      main: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(pollerState, reduxState) {
          var address, tokenAddress, currentBalance, nextBalance;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  address = getAddress(reduxState);
                  tokenAddress = getTokenAddress(reduxState);
                  currentBalance = pollerState.currentBalance;
                  _context.prev = 3;
                  _context.next = 6;
                  return (0, _retry2.default)(function () {
                    return dynamicToken.fetchBalance(address, tokenAddress);
                  });

                case 6:
                  nextBalance = _context.sent;

                  if (nextBalance !== currentBalance) {
                    dispatch(tokenBalanceUpdate(nextBalance));
                    currentBalance = nextBalance;
                  }
                  _context.next = 13;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context['catch'](3);

                  dispatch(tokenBalanceUpdateFailed(_context.t0));

                case 13:
                  return _context.abrupt('return', { currentBalance: currentBalance });

                case 14:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined, [[3, 10]]);
        }));

        function main(_x, _x2) {
          return _ref3.apply(this, arguments);
        }

        return main;
      }()
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/middleware/pollTokenBalance.js
// module id = 1155
// module chunks = 0